import React from 'react'
import StaticPage from '../components/StaticPage'
import ContactForm from '../components/ContactForm'

function MembershipPage() {
  return (
    <StaticPage
      title="Join Wingbeat Paragliding Club"
      intro="Come and fly the Scottish Borders with us"
    >
      <p>
        Wingbeat is a small, friendly, informal club - no constitution, no committee, just a group
        of folk with a common love of paragliding and the outdoors. We fly the soft green hills of
        the Teviot, Ettrick and Yarrow Valleys and offer everyone a warm welcome to the Borders.
      </p>

      <h2>Who can join</h2>
      <p>
        Pilots with a BHPA rating (or equivalent) and appropriate insurance are welcome. If you're
        newer to the sport, get in touch anyway - we're happy to help you get to know the sites and
        fly with someone who knows them.
      </p>

      <h2>Fees</h2>
      <p>
        There are no Wingbeat membership fees. The only costs are your own{' '}
        <a href="https://www.shpf.co.uk/" target="_blank" rel="noopener noreferrer">SHPF</a>{' '}
        (Scottish Hang gliding and Paragliding Federation) fees, and an optional donation towards
        the running of the Witchieknowe weather station, which the club maintains for members.
      </p>

      <h2>Respect the sites</h2>
      <p>
        Our access depends on good relationships with local farmers and landowners. Please read the{' '}
        <a href="/sites">site guides</a> and follow the <a href="/safety">safety guidelines</a>,
        including staying off sites during lambing and other sensitive times.
      </p>

      <h2>Get in touch to join</h2>
      <p>
        Fill in the form below and we'll be in touch. Tell us a little about your flying experience
        so we can point you at the right sites.
      </p>
      <ContactForm kind="join" />
    </StaticPage>
  )
}

export default MembershipPage
